// Campus photo for /colleges/university-of-connecticut: CC0 1.0, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACampus_view_-_University_of_Connecticut_-_DSC09948.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-connecticut/; credited under the photo.
const photo = {
    "slug": "university-of-connecticut",
    "alt": "Brick academic buildings, lawns and walkways on the University of Connecticut campus in Storrs, Connecticut",
    "src": "/colleges/university-of-connecticut/campus-1600.webp",
    "srcSmall": "/colleges/university-of-connecticut/campus-800.webp",
    "srcMid": "/colleges/university-of-connecticut/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-connecticut/og.jpg",
    "title": "Campus view - University of Connecticut - DSC09948",
    "author": "Daderot",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACampus_view_-_University_of_Connecticut_-_DSC09948.JPG",
    "read": "2026-10-02"
};

export default photo;
